import React, { useState } from 'react';
import {
  HelpText,
  Input,
  Label,
  Loader,
  ValidationMessage
} from '@gjensidige/builders-components';

import styles from '../../style.scss';
import { InputTextBoxProps } from '../../Types';

export const InputTextBox: React.FC<InputTextBoxProps> = ({
  inputProps
}: InputTextBoxProps) => {
  const {
    id,
    labelText,
    name,
    onChange,
    onBlur,
    value,
    placeholder,
    className,
    labelClassName,
    invalid,
    errorText,
    helpText,
    helpTextToggleLabel,
    helpTextCloseLabel,
    isHelpTextAlwaysVisible,
    postfixLoader,
    inputMode,
    prefixImage,
    inputWrapperClassName,
    inputHelpTextId,
    moreInfoModal,
    autoCompleteLabel
  } = inputProps;

  let postfixLoaderComponent;
  if (postfixLoader) {
    postfixLoaderComponent = (
      <div className={styles.inputLoaderWrapper}>
        <Loader />
      </div>
    );
  }

  const [isToggled, setIsToggled] = useState(false);

  const getInputWrapperClassName = (inputWrapperClassName: string) => {
    switch (inputWrapperClassName) {
      case 'ssn':
        return styles.inputWrapperClassSSN;
      case 'phone-number':
        return styles.inputWrapperClassPhoneNumber;
      case 'reg-nr':
        return styles.inputWrapperClassRegNr;
      case 'street-address':
        return styles.inputWrapperClassStreetAddress;
      case 'zip-code':
        return styles.inputWrapperClassZipCode;
      case 'municipality':
        return styles.inputWrapperClassMunicipality;
      case 'property-id':
        return styles.inputWrapperClassPropertyId;
      default:
        return styles.inputWrapperClassDefault;
    }
  };

  return (
    <>
      {labelText && (
        <Label htmlFor={id || ''} className={labelClassName}>
          {labelText}
        </Label>
      )}
      {helpText && (
        <HelpText
          open={isHelpTextAlwaysVisible || isToggled}
          onToggle={() => setIsToggled(!isToggled)}
          toggle={
            isHelpTextAlwaysVisible
              ? ''
              : (isToggled ? helpTextCloseLabel : helpTextToggleLabel) ||
                labelText ||
                ''
          }
          htmlFor={id || ''}
        >
          {helpText}
        </HelpText>
      )}
      <Input
        id={id || ''}
        name={name || ''}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        placeholder={placeholder}
        className={`${className || ''}`}
        invalid={invalid}
        inputMode={inputMode}
        prefix={prefixImage}
        wrapperProps={{
          className: `${
            prefixImage ? styles.inputWithPrefixImage : ''
          } ${getInputWrapperClassName(inputWrapperClassName || '')}`
        }}
        suffix={postfixLoaderComponent}
        aria-describedby={`${inputHelpTextId || ''} ${
          moreInfoModal?.ariaDescribedBy || ''
        }`}
        {...(autoCompleteLabel ? { autoComplete: autoCompleteLabel } : {})}
      />
      {invalid && errorText && (
        <ValidationMessage htmlFor={id || ''}>{errorText}</ValidationMessage>
      )}
    </>
  );
};
